exports.install = function (Vue, options) {
	Vue.prototype.api.Speciesdetails = {
		read(value)//获取物种详情单条数据
		{
			return Vue.prototype.axiosget("/api/rl/Speciesdetails/read",value)
			.then((response)=>{
				return response;
			});
		},
		getList(value={})//获取物种详情列表数据
		{
			return Vue.prototype.axiosget("/api/rl/Speciesdetails/getList",value)
			.then((response)=>{
				return response;
			});
		},
		add(value)//添加物种详情
		{
			return Vue.prototype.axiospost("/api/rl/Speciesdetails/add",value)
			.then((response)=>{
				return response;
			});
		},
		update(value)//修改物种详情
		{
			return Vue.prototype.axiospost("/api/rl/Speciesdetails/update",value)
			.then((response)=>{
				return response;
			});
		},
		delete(value)//删除物种详情
		{
			return Vue.prototype.axiospost("/api/rl/Speciesdetails/delete",value)
			.then((response)=>{
				return response;
			});
		}
	};
}
